import React, { useState, useEffect } from "react";
import { Table, Button } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import { Spinner } from "react-bootstrap";
import whatsapp from "../../../src/assets/img/WhatsApp_icon.png";
import { Link, useNavigate } from "react-router-dom";

export default function Resulthistory() {
  const user_id = localStorage.getItem("userid");
  const devid = localStorage.getItem("dev_id");
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [totalComm, settotalComm] = useState([]);
  const [totalPlayed, settotalPlayed] = useState([]);
  const [RedeemtotalAmount, setRedeemtotalAmount] = useState([]);

  const [Refcomm, setRefcomm] = useState([]);
  const [RefBonus, setRefBonus] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [redeemAmount, setRedeemAmount] = useState("");
  const [TotalBonus, setTotalBonus] = useState("");
  const [BonusMin, setBonusMin] = useState("");
  const [BonusMax, setBonusMax] = useState("");
  const [error, setError] = useState("");
  const [loadingbutton, setLoadingbutton] = useState(false);
  const [itemsToShow, setItemsToShow] = useState(20);
  const [ref_message, setref_message] = useState(null);
  const [refData, setRefData] = useState({ ref_code: "", ref_by: "" });
  const [apiResponse, setApiResponse] = useState(null);
  const [showButton, setShowButton] = useState(false);
  // const pageSize = 5;
  const handleSearch = (value) => {
    const filtered = data.filter((item) =>
      Object.values(item).some(
        (field) =>
          typeof field === "string" &&
          field.toLowerCase().includes(value.toLowerCase()),
      ),
    );
    setSearchText(value);
    setFilteredData(filtered);
    setCurrentPage(1);
  };

  const bonuslist = async () => {
    const user_id = localStorage.getItem("userid");
    const requestData = {
      user_id: user_id,
    };
    const config = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL_NODE}bonus-report-list`,
      headers: {
        "Content-Type": "application/json",
      },
      data: requestData,
    };
    try {
      const response = await axios(config);
      console.log(response);
      if (response.data.success == "1") {
        setData(response.data.data);
        settotalComm(response.data.total_comm);
        settotalPlayed(response.data.total_played);
        setRefcomm(response.data.commissionRate);
        setRefBonus(response.data.total_comm);
        setRedeemtotalAmount(response.data.RedeemtotalAmount);

        setTotalBonus(response.data.total_bonus);
        setBonusMin(response.data.bounsmin);
        setBonusMax(response.data.bounsmax);
      } else {
        console.log("no record found");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  const getProfile = async () => {
    // setLoadButton(false);
    const apiUrl = `${process.env.REACT_APP_API_URL_NODE}user-profile`;
    const requestData = {
      app_id: process.env.REACT_APP_API_ID,
      user_id,
      device_id: devid,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
      // setLoadButton(true);

      if (data.is_login === "0") window.location.href = "/";

      if (data.success === "1") {
        setApiResponse(data.is_bonus);
        setref_message(data.ref_message);
        setRefData({ ref_code: data.ref_code, ref_by: data.ref_by });
        setShowButton(!data.ref_by); // Show button only if ref_by is empty
      } else {
        console.error("API Error:", data.message);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    bonuslist();
    getProfile();
  }, []);
  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(
        "https://rpk90.com/create-account?reffercode=" + refData.ref_code,
      )
      .then(() => {
        Swal.fire(
          "Copied!",
          "Your refer Link has been copied to the clipboard.",
          "success",
        );
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
        Swal.fire("Error", "Failed to copy the refer code.", "error");
      });
  };
  // const formatDateString = (dateString) => {
  //   const date = new Date(dateString);
  //   return date.toLocaleDateString();
  // };
  const navigate = useNavigate();

  const columns = [
    {
      title: "Date",
      dataIndex: "_id",
      key: "date",
    },

    {
      title: "Total Played",
      dataIndex: "totalAmount",
      key: "total",
    },
    {
      title: "Comm",
      dataIndex: "winAmount",
      key: "winAmount",
      render: (text) => parseFloat(text).toFixed(2),
    },

    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          type="link"
          onClick={() => navigate(`/bonus-report-details/${record._id}`)}
        >
          View
        </Button>
      ),
    },
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    });
    return () => clearTimeout(timer);
  }, []);

  const redeemBonus = async (event) => {
    event.preventDefault();
    if (!redeemAmount || redeemAmount < BonusMin || redeemAmount > BonusMax) {
      setError(
        "Please enter a valid amount between " + BonusMin + " and " + BonusMax,
      );
      return;
    }
    setError("");
    setLoadingbutton(true);
    const requestData = {
      user_id: user_id,
      amount: redeemAmount,
    };
    const config = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL_NODE}bonus-report-redem`,
      headers: {
        "Content-Type": "application/json",
      },
      data: requestData,
    };
    try {
      const response = await axios(config);
      if (response.data.success == "1") {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Your bonus has been redeemed successfully!",
        });
        bonuslist();
        setLoadingbutton(false);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.message,
        });
      }
    } catch (error) {
      console.error("Error redeeming bonus:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while redeeming your bonus. Please try again later.",
      });
    }
  };

  const loadMore = () => {
    setItemsToShow(itemsToShow + 20);
  };

  return (
    <div>
      {isLoading && (
        <div className="spinner-wrapper">
          <div className="loadernew2"></div>
        </div>
      )}
      {!isLoading && (
        <section id="Help" className="margin-bottom-88">
          <div className="margin-bottom-49 mb-0 pb-5">
            <div className="container">
              <div className="row">
                <div className="col-md-6 offset-md-3 col-12">
                  {/* <h2 className="comissionrate">
                    98 के रेट साथ कमीशन नही है 95 के रेट के साथ 3 परसेंट कमीशन
                    मिलेगी जिसको चाइए वो deposit chat pe msg करके करवा सकता
                    हैं।{" "}
                  </h2> */}
                  {/* <h5 className="text-dark text-center">Bonus Report</h5> */}
    <p
  className="text-center"
  style={{ color: "red", fontWeight: "bold" }}
>
  {/* 98 के रेट साथ कमीशन नही है 95 के रेट के साथ 3 परसेंट कमीशन मिलेगी जिसको चाइए वो deposit chat pe msg करके करवा सकता हैं। */}
  अगर आप अपने रेफरल कोड से किसी को जोड़ते हैं, तो आपको उसकी खेली हुई गेम का 5% कमीशन तुरंत मिलेगा।
</p>

                  <div className="referalcode">
                    {ref_message}
                    {/* आप अपने REFERAL CODE से जितने भी खिलाड़ी जोड़ोगे, उनकी खेली
                    हुई गेम का आपको 10 % मिलेगा। और वो जितने लोगों को जोड़ेंगे
                    अपने REFERAL CODE से, उसका भी आपको 2 से 5 परसेंट मिलेगा। */}
                  </div>
                  <div className="chatsupportdesign">
                    <h4>Reffer Link</h4>
                    <div className="referlinkdesign">
                      <p>
                        Referral Link:
                        https://rpk90.com/create-account?reffercode=
                        {refData.ref_code}
                      </p>
                      <div className="d-flex justify-content-center gap-2 align-items-center">
                        <div>
                          <button
                            className="buttoncopylink"
                            onClick={copyToClipboard}
                          >
                            Copy Link
                          </button>
                        </div>
                      <div className="whatsappicon">
  <a
    href={`https://wa.me/?text=${encodeURIComponent(
      `गली दिसावर गेम खेलने वाले DOWNLOAD करे.....rpk 90 ऐप क्योंकि इसमें मिलता है आपको सबसे ज्यादा रेट 10के 950 रुपए और सबसे FAST एंड SAFE PAYMENT

https://rpk90.com/create-account?reffercode=${refData?.ref_code || ""}`
    )}`}
    target="_blank"
    rel="noopener noreferrer"
  >
    <img src={whatsapp} alt="whatsapp" />
  </a>
</div>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between", 
                      width: "100%",
                      backgroundColor: "#e1c14e", // Blue background
                      // padding: "10px 15px",      
                      boxSizing: "border-box",
                      // borderRadius: "5px",       
                    }}
                  >
                    {/* Heading */}
                    <h3
                      style={{
                        margin: "0",
                        padding: "0",
                        textAlign: "center",
                        lineHeight: "1",
                        color: "#fff",           // White text
                        // fontSize: "18px",
                        fontWeight: "600"
                      }}
                    >
                      Refer And Earn
                    </h3>

                    {/* Button Link */}
                    <Link
                      to="/View-Child"
                      style={{
                        textDecoration: "none",
                        color: "#fff",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "6px",
                        padding: "6px 12px",
                        margin: "0",
                        borderRadius: "6px",
                        background: "linear-gradient(135deg, #667eea, #764ba2)",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Slight shadow
                        transition: "all 0.3s ease",
                        fontWeight: "600",
                        fontSize: "13px",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-1px)";
                        e.currentTarget.style.boxShadow = "0 4px 6px rgba(0,0,0,0.15)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
                      }}
                    >
                      <h3
                        style={{
                          margin: "0",
                          padding: "0",
                          fontSize: "13px",
                          fontWeight: "600",
                          lineHeight: "1",
                          color: "#fff"
                        }}
                      >
                        Referral User
                      </h3>

                      <span style={{ fontSize: "14px", margin: 0 }}>→</span>
                    </Link>
                  </div>
                </div>




                <div className="col-12">
                  <table className="table bonusreportth">
                    <thead className="bonusreportth">
                      <th>Total Played</th>
                      <th>Total Bonus</th>
                      <th>Remaining Bonus</th>
                      <th>Total Redeem Amount</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{totalPlayed}</td>
                        <td>{TotalBonus}</td>
                        <td>{RefBonus}</td>
                        <td>{RedeemtotalAmount}</td>

                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="col-md-12">
                  <h6 className="text-dark redeem">
                    Enter Redeem Amount
                    <span className="d-block text-danger">
                      (Min - {BonusMin} and Max- {BonusMax} can withdraw)
                    </span>
                  </h6>
                  <div className="row align-items-center">
                    <div className="col-8 col-sm-9">
                      <input
                        type="number"
                        required=""
                        onChange={(e) => setRedeemAmount(e.target.value)}
                        placeholder="Enter Amount"
                        name="amount"
                        className="form-control bonusreportinput"
                      />
                    </div>
                    <div className="col-4 col-sm-3">
                      <button
                        type="button"
                        onClick={redeemBonus}
                        className="playgames bonsureport w-100"
                        disabled={loadingbutton}
                      >
                        Submit {loadingbutton && <Spinner animation="border" />}
                      </button>
                    </div>
                    {error && <p className="text-danger">{error}</p>}
                  </div>
                </div>
                <div className="col-md-12 mt-3 pb-5">
                  <Table
                    dataSource={
                      searchText
                        ? filteredData.slice(0, itemsToShow)
                        : data.slice(0, itemsToShow)
                    }
                    columns={columns}
                    pagination={false}
                  />
                  {data.length > itemsToShow && (
                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                      <Button onClick={loadMore}>Load More</Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
